/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';

import styles from '../../../../common-scss/DetailsPage.module.scss';

const OptionsFitted = ({ ...props }) => {
  const { t, options } = props;

  if (!options || options.length <= 0) {
    return (
      <p>
        <b>{t('general:messages.please_note')}: </b>
        {t('general:assets.messages.no_options_available')}
      </p>
    );
  }

  return (
    <div className={styles['options-fitted']}>
      <table className={styles.productTable}>
        <thead>
          <tr>
            <th>{t('general:option_number')}</th>
            <th>{t('general:description')}</th>
            <th>{t('general:qty')}</th>
          </tr>
        </thead>
        <tbody>
          {options.map(option => (
            <tr key={option.id}>
              <td>{option.er_option_id}</td>
              <td>{option.er_option_description}</td>
              <td>{option.er_option_quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default translate()(OptionsFitted);
